// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"SectionLRA_TheComp__io7qR"};